/** Distinguishes the counter poll deadline from a component unmount/caller cancellation. */
export const counterPollTimeoutReason = "ANL_COUNTER_POLL_TIMEOUT";
/** A stalled counter read must release the single-flight poll before it hides a new PLC M0 edge. */
export const COUNTER_POLL_TIMEOUT_MS = 2_500;
export const COUNTER_POLL_RECOVERY_MS = 1_000;
export const COUNTER_POLL_MAX_RECOVERY_MS = 8_000;

export function counterPollRecoveryDelay(consecutiveFailures: number) {
  const exponent = Math.max(0, Math.min(consecutiveFailures - 1, 3));
  return Math.min(COUNTER_POLL_RECOVERY_MS * 2 ** exponent, COUNTER_POLL_MAX_RECOVERY_MS);
}

export function isCounterPollTimeout(signal: AbortSignal | null | undefined) {
  return signal?.aborted === true && signal.reason === counterPollTimeoutReason;
}
